import { HTTP_INTERCEPTORS } from '@angular/common/http';
import { EnvironmentProviders, makeEnvironmentProviders } from '@angular/core';
import { ErrorNotificationsInterceptor } from '../interceptors/error-notifications-interceptor';


export function provideErrorNotifications(): EnvironmentProviders {
    return makeEnvironmentProviders([
        {
          provide: HTTP_INTERCEPTORS,
          useClass: ErrorNotificationsInterceptor,
          multi: true,
        }
    ]);
}